import React, { Component } from 'react';
import { Container, FlexGrid, Header, Image, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import styles from './ErrorBoundary.module.css';

const cx = classnames.bind(styles);

class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    staticContext: PropTypes.shape({
      statusCode: PropTypes.number,
    }),
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    staticContext: undefined,
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(e) {
    return { hasError: true, statusCode: e.status || 500 };
  }

  render() {
    const { hasError, statusCode } = this.state;
    const { children, staticContext, t } = this.props;

    if (staticContext && statusCode) {
      staticContext.statusCode = statusCode;
    }

    if (hasError) {
      return (
        <Container>
          <FlexGrid>
            <FlexGrid.Column className={cx('column')} tablet={6}>
              <Image alt={t('stationImageAlt')} src="//static.gasbuddy.com/web/generic-station-us.svg" />
            </FlexGrid.Column>
            <FlexGrid.Column className={cx('column')} tablet={6}>
              <Header>
                <Text>{t('errors.oops')}</Text>
                <br />
                <Text>{t('errors.somethingWentWrong')}</Text>
                <br />
              </Header>
              <Text as="p" color="midnight" size="lg">{t('fillUpMessage', { ns: 'feature' })}</Text>
              <Text as="p" color="grey">
                {t('errors.errorDescription')}
              </Text>
            </FlexGrid.Column>
          </FlexGrid>
        </Container>
      );
    }

    return children;
  }
}

export default withTranslation(['miscellaneous', 'feature'], { withRef: true })(ErrorBoundary);
